const PS_POINTER_UI =
  ".ps__thumb-x, .ps__thumb-y, .ps__thumb, .ps__rail-x, .ps__rail-y"

/**
 * perfect-scrollbar exposes thumbs/rails as focusable, sometimes with implicit
 * button semantics. They are pointer drag affordances and should be hidden from AT.
 *
 * @param {ParentNode | null | undefined} root - Ancestor of the .ps element (e.g. CustomScrollbar root or Login root).
 */
export function stripPerfectScrollbarThumbTabindex(root) {
  if (!root?.querySelectorAll) return
  root.querySelectorAll(PS_POINTER_UI).forEach((el) => {
    el.setAttribute("tabindex", "-1")
    el.removeAttribute("role")
    el.removeAttribute("aria-label")
    el.setAttribute("aria-hidden", "true")
  })
}
